import { FileSizeModel } from './file-size.model';
import { FileRevisionModel } from './file-revision.model';
import { CheckOutInfoModel } from './check-out-info.model';
import { FileVersionModel } from './file-version.model';

/**
 * File model based on Swagger specification
 */
export interface FileModel {
    Id?: string;
    Name?: string;
    ProjectId: string;
    Path: string;
    Content?: string;
    Size?: FileSizeModel;
    Checksum?: string;
    CurrentRevision?: FileRevisionModel;
    CheckOutInfo?: CheckOutInfoModel;
    Status?: FileStatus;
    CreatedAtUtc?: Date;
    LastModifiedAtUtc?: Date;
    CreatedAt?: Date;
    UpdatedAt?: Date;
    VersionCount?: number;
    Versions?: FileVersionModel[];
}

/**
 * File status enum based on Swagger specification
 */
export enum FileStatus {
    Available = 0,
    CheckedOut = 1,
    Locked = 2,
    Archived = 3,
    Deleted = 4,
    Error = 5
}



